import ApiClient from '@/utils/api-client'
export default {
  // 首页数据接口
  getCommon(): any {
    return ApiClient.get(`/common/index/web_index`)
  },
  //获取更多网店分类+列表集合
  getOtherCommon(): any {
    return ApiClient.get(`/common/index/other_category`)
  },
  // 获取日淘文章
  getCommonArticleList(params?:any): any {
    return ApiClient.get(`/common/article/get_list`,params)
  },
  // 获取平台分类
  getPlatformList(params?:any): any {
    return ApiClient.get(`/common/index/get_platform_list`, params)
  },
  // 获取常用url地址配置
  getSiteConfig(params?:any): any {
    return ApiClient.get(`/common/index/get_site_config`,params)
  },
  // 翻译单词
  getTranslate(params?:any): any {
    return ApiClient.get(`/common/index/translate`,params)
  },
  // 根据id获取新闻内容详情
  getArticleInfo(params?:any): any {
    return ApiClient.get(`/common/article/info`,params)
  },
  // 获取地域列表
  getCountryList(params?:any): any {
    return ApiClient.get(`/common/shipFee/get_country_list`, params)
  },
  // 获取运费计算
  getFee(params?:any): any {
    return ApiClient.get(`/common/shipFee/get_fee`, params)
  },
  // 地区
  // /common/index/get_region:post{parent_id: } 获取一级 国家地区
  // /common/index/get_region:post{parent_id: parent_id} 获取二级 三级 四级
  getRegion(params?:any): any {
    return ApiClient.post(`/common/index/get_region`, params)
  },
  // 获取帮助中心
  getHelpArticleList(params?:any): any {
    return ApiClient.post(`/common/article/help_article_list`, params)
  },
  // 获取文章详情
  getInfoJson(params?:any): any {
    return ApiClient.post(`/common/article/info_json`, params)
  },
  checkTextImage(params?:any): any {
    return ApiClient.post(`/common/index/check_text_image`, params)
  },
}
